import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import "./newPaymentVoucher.css";
import Select from "react-select";
import { useSupplierContext } from "../../context/SupplierContext";
import { usePaymentVoucherContext } from "../../context/PaymentVoucherContext";

const NewPaymentVoucher = () => {
  const navigate = useNavigate();
  const { fetchSuppliers, suppliers } = useSupplierContext();
  const {
    createPaymentVoucher,
    fetchSupplierInvoices,
    loading,
    error,
    success,
  } = usePaymentVoucherContext();

  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [invoices, setInvoices] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [amount, setAmount] = useState("");
  const [paymentType, setPaymentType] = useState("كاش");
  const [checkNumber, setCheckNumber] = useState("");
  const [checkBank, setCheckBank] = useState("");
  const [checkDueDate, setCheckDueDate] = useState("");
  const [notes, setNotes] = useState("");
  const [createdAt, setCreatedAt] = useState(() => {
    const today = new Date();
    return today.toISOString().slice(0, 10);
  });
  const [loadingInvoices, setLoadingInvoices] = useState(false);

  useEffect(() => {
    fetchSuppliers();
  }, []);

  // عند اختيار مورد، جلب فواتيره
  const handleSupplierChange = async (supplier) => {
    setSelectedSupplier(supplier);
    setSelectedInvoice(null);
    setInvoices([]);
    setAmount("");

    if (supplier) {
      setLoadingInvoices(true);
      try {
        const data = await fetchSupplierInvoices(supplier.value);
        setInvoices(data);
      } catch (err) {
        console.error("Error fetching invoices:", err);
        alert("حدث خطأ أثناء جلب فواتير المورد");
      } finally {
        setLoadingInvoices(false);
      }
    }
  };

  // عند اختيار فاتورة
  const handleInvoiceChange = (invoice) => {
    setSelectedInvoice(invoice);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedSupplier) {
      alert("يرجى اختيار المورد");
      return;
    }

    if (!selectedInvoice) {
      alert("يرجى اختيار الفاتورة");
      return;
    }

    if (!amount || parseFloat(amount) <= 0) {
      alert("يرجى إدخال مبلغ صحيح");
      return;
    }

    if (parseFloat(amount) > selectedInvoice.remaining_amount) {
      alert("المبلغ المدفوع أكبر من المبلغ المتبقي");
      return;
    }

    if (paymentType === "شيك") {
      if (!checkNumber || !checkBank || !checkDueDate) {
        alert("يرجى إدخال جميع بيانات الشيك");
        return;
      }
    }

    const voucherData = {
      supplier_id: selectedSupplier.value,
      invoice_id: selectedInvoice.id,
      amount: parseFloat(amount),
      payment_type: paymentType,
      created_at: createdAt,
      notes: notes.trim() || null,
    };

    if (paymentType === "شيك") {
      voucherData.check_number = checkNumber.trim();
      voucherData.check_bank = checkBank.trim();
      voucherData.check_due_date = checkDueDate;
    }

    try {
      const response = await createPaymentVoucher(voucherData);
      if (response.status === "success") {
        alert("✅ تم إنشاء سند الصرف بنجاح");
        navigate(`/payment-voucher/${response.voucher_id}`);
      }
    } catch (err) {
      console.error("Error creating voucher:", err);
      alert(err.response?.data?.message || "حدث خطأ أثناء إنشاء سند الصرف");
    }
  };

  return (
    <div className="new-receipt-voucher-page">
      <div className="receipt-voucher-container">
        <h1 className="page-title">إنشاء سند صرف جديد</h1>

        <form onSubmit={handleSubmit} className="voucher-form">
          {/* اختيار المورد */}
          <div className="form-group">
            <label>
              المورد <span className="required">*</span>
            </label>
            <Select
              value={selectedSupplier}
              onChange={handleSupplierChange}
              options={suppliers.map((supplier) => ({
                value: supplier.id,
                label: `${supplier.full_name} - ${supplier.phone}`,
              }))}
              placeholder="-- اختر المورد --"
              isSearchable
              isClearable
              noOptionsMessage={() => "لا توجد خيارات"}
              className="react-select-container"
              classNamePrefix="react-select"
              filterOption={(option, inputValue) => {
                if (!inputValue) return true;
                const searchWords = inputValue
                  .toLowerCase()
                  .split(" ")
                  .filter((w) => w);
                const optionText = option.label.toLowerCase();
                return searchWords.every((word) => optionText.includes(word));
              }}
            />
          </div>

          {/* اختيار الفاتورة */}
          {selectedSupplier && (
            <div className="form-group">
              <label>
                الفاتورة <span className="required">*</span>
              </label>
              {loadingInvoices ? (
                <p className="loading-text">جارٍ تحميل الفواتير...</p>
              ) : invoices.length === 0 ? (
                <p className="no-invoices">
                  لا توجد فواتير غير مدفوعة لهذا المورد
                </p>
              ) : (
                <Select
                  value={selectedInvoice}
                  onChange={handleInvoiceChange}
                  options={invoices.map((invoice) => ({
                    ...invoice,
                    value: invoice.id,
                    label: `فاتورة #${
                      invoice.id
                    } - المبلغ الكلي: ${invoice.total_amount.toFixed(
                      2
                    )} ₪ - المدفوع: ${invoice.paid_amount.toFixed(
                      2
                    )} ₪ - المتبقي: ${invoice.remaining_amount.toFixed(2)} ₪`,
                  }))}
                  placeholder="-- اختر الفاتورة --"
                  isSearchable
                  isClearable
                  noOptionsMessage={() => "لا توجد خيارات"}
                  className="react-select-container"
                  classNamePrefix="react-select"
                  filterOption={(option, inputValue) => {
                    if (!inputValue) return true;
                    const searchWords = inputValue
                      .toLowerCase()
                      .split(" ")
                      .filter((w) => w);
                    const optionText = option.label.toLowerCase();
                    return searchWords.every((word) =>
                      optionText.includes(word)
                    );
                  }}
                />
              )}
            </div>
          )}

          {/* المبلغ */}
          {selectedInvoice && (
            <>
              <div className="form-group">
                <label htmlFor="amount">
                  المبلغ المدفوع <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="amount"
                  value={amount}
                  onChange={(e) => {
                    const value = e.target.value.replace(/[^0-9.]/g, "");
                    setAmount(value);
                  }}
                  placeholder="أدخل المبلغ"
                  required
                />
                <small className="helper-text">
                  المبلغ المتبقي: {selectedInvoice.remaining_amount.toFixed(2)}{" "}
                  ₪
                </small>
              </div>

              <div className="form-group">
                <label htmlFor="created_at">
                  تاريخ السند <span className="required">*</span>
                </label>
                <input
                  type="date"
                  id="created_at"
                  value={createdAt}
                  onChange={(e) => setCreatedAt(e.target.value)}
                  required
                />
              </div>

              <div className="form-group">
                <label htmlFor="payment_type">
                  نوع الدفع <span className="required">*</span>
                </label>
                <select
                  id="payment_type"
                  value={paymentType}
                  onChange={(e) => setPaymentType(e.target.value)}
                  required
                >
                  <option value="كاش">كاش</option>
                  <option value="شيك">شيك</option>
                </select>
              </div>

              {paymentType === "شيك" && (
                <>
                  <div className="form-group">
                    <label htmlFor="check_number">
                      رقم الشيك <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="check_number"
                      value={checkNumber}
                      onChange={(e) => setCheckNumber(e.target.value)}
                      placeholder="أدخل رقم الشيك"
                      required={paymentType === "شيك"}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="check_bank">
                      البنك <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      id="check_bank"
                      value={checkBank}
                      onChange={(e) => setCheckBank(e.target.value)}
                      placeholder="أدخل اسم البنك"
                      required={paymentType === "شيك"}
                    />
                  </div>

                  <div className="form-group">
                    <label htmlFor="check_due_date">
                      تاريخ الاستحقاق <span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      id="check_due_date"
                      value={checkDueDate}
                      onChange={(e) => setCheckDueDate(e.target.value)}
                      required={paymentType === "شيك"}
                    />
                  </div>
                </>
              )}

              <div className="form-group">
                <label htmlFor="notes">ملاحظات</label>
                <textarea
                  id="notes"
                  value={notes}
                  onChange={(e) => setNotes(e.target.value)}
                  placeholder="أدخل ملاحظات إضافية (اختياري)"
                  rows="3"
                />
              </div>

              <div className="form-actions">
                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? "جارٍ الحفظ..." : "حفظ سند الصرف"}
                </button>
                <Link to="/payment-vouchers" className="cancel-btn">
                  إلغاء
                </Link>
              </div>
            </>
          )}
        </form>
      </div>
    </div>
  );
};

export default NewPaymentVoucher;
